import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
    toggleDevice,
    toggleDevicePublic,
    toggleDeviceForecast,
    updateDevice,
    getDevices,
    setCurrentDevice,
    toggleReports,
} from '../../actions/deviceActions';
import { toggleModal } from '../../actions/modalActions';

class SingleDevice extends Component {
    constructor(props) {
        super(props);

        this.state = {
            enabled: this.props.deviceEnabled,
            availabled: this.props.deviceAvailable,
            edited: false,
            city: this.props.deviceCity,
            address: this.props.deviceAddress,
        }
    }

    onDeviceUpdate = () => {
        const { deviceCity, deviceAddress, deviceId, updateDevice, getDevices } = this.props;
        const { city, address, edited } = this.state;

        if ((!city && deviceCity) || (!address && deviceAddress)) {
            return;
        }

        if (edited &&
            (city !== deviceCity || address !== deviceAddress)) {
            const data = {
                city,
                address
            };

            updateDevice(deviceId, data).then(() => getDevices());
        }

        this.setState({ edited: !edited });
    }

    toggleLogoModal = () => {
        this.props.setCurrentDevice(this.props.deviceId);
        this.props.toggleModal('logoModal');
    }

    toggleReportsModal = () => {
        this.props.setCurrentDevice(this.props.deviceId);
        this.props.toggleModal('reportsModal');
    }

    toggleReports = () => {
        this.props.toggleReports(this.props.deviceId, { send_reports: !this.props.sendReports })
            .then(() => this.props.getDevices());
    }

    toggleForecast = () => {
        // Note: Doesn't update props on fetch error
        this.props.toggleDeviceForecast(this.props.deviceId)
            .then(() => this.props.getDevices());
    }

    render() {
        const { deviceId, deviceAddress, deviceCity, updateDevice, firstLogo, secondLogo, sendReports, deviceForecastEnabled } = this.props;
        const { city, address, edited } = this.state;
        const btnEnablingClass = this.state.enabled ? "btn btn-success btn--fixed-width" : "btn btn-danger btn--fixed-width";
        const btnHidingClass = this.state.availabled ? "btn btn-info btn--fixed-width" : "btn btn-danger btn--fixed-width";
        const btnEditingClass = this.state.edited ? "btn btn-success btn--fixed-width" : "btn btn-primary btn--fixed-width";
        const logosCount = !!firstLogo + !!secondLogo;
        const logosMax = 2;

        return (
            <tr>
                <td>
                    <div>{`${deviceId}`}</div>
                </td>
                <td>
                    {
                        !edited ?
                        <div>{`${city}, ${address}`}</div> :
                        <div>
                            <form className="devices-form form-inline">
                                <div className="form-group devices-form__group">
                                    <input
                                        id="device-city"
                                        className="form-control devices-form__city"
                                        type="text"
                                        value={city}
                                        onChange={(e) => {
                                            this.setState({
                                                city: e.target.value
                                            })
                                        }}
                                    />
                                    <input
                                        id="device-address"
                                        className="form-control devices-form__address"
                                        type="text"
                                        value={address}
                                        onChange={(e) => {
                                            this.setState({
                                                address: e.target.value
                                            })
                                        }}
                                    />
                                </div>
                            </form>
                        </div>
                    }
                </td>
                {
                    !edited
                    ? <td className="text-center">
                        {logosCount}/{logosMax}
                    </td>
                    :  <td className="text-right">
                        <button
                            className="btn btn-secondary  btn--fixed-width"
                            type="button"
                            onClick={this.toggleLogoModal}
                            >
                            <FormattedMessage id="dashboard.buttons.device.add.logo"/>
                        </button>
                    </td>
                }
                {
                    !edited
                    ? <td className="text-center">
                        <label className="text-nowrap">
                            <input type="checkbox" checked={sendReports} onChange={this.toggleReports} />
                            <span className="pl-2">
                                <FormattedMessage id="dashboard.buttons.device.reports.active"/>
                            </span>
                        </label>
                    </td>
                    :  <td className="text-right">
                        <button
                            className="btn btn-secondary  btn--fixed-width"
                            type="button"
                            onClick={this.toggleReportsModal}
                        >
                            <FormattedMessage id="dashboard.buttons.device.reports.edit"/>
                        </button>
                    </td>
                }
                {/** Forecast */}
                <td className="text-center">
                    <label className="text-nowrap">
                        <input
                            type="checkbox"
                            checked={deviceForecastEnabled}
                            onChange={this.toggleForecast}
                        />
                        <span className="pl-2">
                            <FormattedMessage id="dashboard.buttons.device.forecast.active" />
                        </span>
                    </label>
                </td>
                <td className="text-right">
                {
                    !edited ?
                        <button
                            className={btnEditingClass}
                            onClick={this.onDeviceUpdate}
                            disabled={!this.state.enabled}
                        >
                            <FormattedMessage id="dashboard.buttons.device.edit"/>
                    </button> :
                    <button
                        className="btn btn-secondary btn--fixed-width"
                        type="button"
                        onClick={() => {
                            updateDevice(deviceId, {
                                geocodingRequested: true
                            });
                        }}
                    >
                        <FormattedMessage id="dashboard.buttons.device.default"/>
                </button>
                }
                </td>
                <td className="text-right">
                    {
                        !edited
                        ? <button
                            className={btnEnablingClass}
                            onClick={() => {
                                this.props.toggleDevice(deviceId);
                                this.setState({ enabled: !this.state.enabled })
                            }}
                        >
                            { !this.state.enabled ?
                            <FormattedMessage id="dashboard.buttons.device.enable"/> :
                            <FormattedMessage id="dashboard.buttons.device.disable"/> }
                        </button>
                        : <button
                            className="btn btn-danger btn--fixed-width"
                            onClick={() => {
                                this.setState({
                                    city: deviceCity,
                                    address: deviceAddress,
                                    edited: !edited
                                });
                            }}
                    >
                        <FormattedMessage id="edit.user.buttons.cancel" />
                    </button>
                    }
                </td>
                <td className="text-right">
                    {!edited
                        ? <button
                            className={btnHidingClass}
                            onClick={() => {
                                this.props.toggleDevicePublic(deviceId);
                                this.setState({ availabled: !this.state.availabled })
                            }}
                            >
                                { this.state.availabled ?
                                    <FormattedMessage id="dashboard.buttons.device.hide"/> :
                                    <FormattedMessage id="dashboard.buttons.device.show"/> }
                            </button>
                        :<button
                            className={btnEditingClass}
                            onClick={this.onDeviceUpdate}
                            >
                                <FormattedMessage id="dashboard.buttons.device.accept"/>
                        </button>
                    }
                </td>
            </tr>
        );
    }
}

export default connect(null, (
    {
        toggleDevice,
        toggleDevicePublic,
        toggleDeviceForecast,
        updateDevice,
        getDevices,
        toggleModal,
        setCurrentDevice,
        toggleReports,
    }
))(injectIntl(SingleDevice));



// WEBPACK FOOTER //
// ./src/components/SingleDevice/SingleDevice.js